export const API_URL = 'https://paymemobile.fr';
export const WS_URL = 'wss://paymemobile.fr:9001';
